import axios from 'axios';

const axiosConfig = (token) => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use((config) => {
    // add token to request headers
    config.headers['Authorization'] = token;
    return config;
  });

  return axiosInstance;
};

export default axiosConfig;
